<p-table
    #table
    class="header-data-table"
    [style]="{ width: '100%' }"
    [tableStyle]="{ 'min-width': '100%' }"
    [columns]="cols"
    [value]="data"
    [rowsPerPageOptions]="globalVar.defaultTableRowsPerPageOptions"
    [paginator]="true"
    [scrollable]="scrollable"
    [resizableColumns]="true"
    columnResizeMode="expand"
    [rows]="10">
    <ng-template
        #header
        let-columns>
        <tr>
            <ng-container *ngFor="let col of columns">
                <th
                    [pSortableColumn]="col.field"
                    [pSortableColumnDisabled]="col.disableSort"
                    pResizableColumn
                    pFrozenColumn
                    [frozen]="col.frozen"
                    [alignFrozen]="col.alignFrozen || 'left'"
                    *ngIf="!col.hidden"
                    [style.width.px]="col.width"
                    [style.max-width.px]="col.maxWidth"
                    [ngClass]="col.class"
                    scope="col">
                    <div
                        [title]="col.header | translate"
                        class="header-th"
                        [style.color]="col.headerColor">
                        <span [ngClass]="col.headerWithEllipsis ? 'header-th-span-with-ellipsis' : ''">{{ col.header | translate }}</span>
                        <img
                            alt="sort"
                            *ngIf="!col.disableSort"
                            src="assets/images/icon_sort.svg" />
                    </div>
                </th>
            </ng-container>
        </tr>
    </ng-template>
    <ng-template
        #body
        let-rowData
        let-rowIndex="rowIndex"
        let-columns="columns">
        <tr>
            <ng-container *ngFor="let col of columns">
                <td
                    *ngIf="!col.hidden"
                    pFrozenColumn
                    [frozen]="col.frozen"
                    [alignFrozen]="col.alignFrozen || 'left'"
                    [style.width.px]="col.width"
                    [style.max-width.px]="col.maxWidth"
                    [class]="col.tdClass">
                    <div>
                        <ng-container [ngSwitch]="col.type">
                            <div
                                class="input-number-with-percentage"
                                *ngSwitchCase="'inputNumberWithPercentage'">
                                <input
                                    type="number"
                                    [placeholder]="0"
                                    [value]="rowData[col.field] | number : '1.0-2'"
                                    (blur)="onCellValueChange(rowData, col.field, $any($event.target).value)" />
                            </div>
                            <div
                                class="input-number-with-plus-minus"
                                *ngSwitchCase="'inputNumberWithPlusMinus'">
                                <ds-button
                                    [disabled]="(rowData[col.field] ?? 0) <= 0"
                                    onkeydown="rowData[col.field] = Math.max(0, (rowData[col.field] ?? 0) - 1); onCellValueChange(rowData, col.field, rowData[col.field])"
                                    (click)="
                                        rowData[col.field] = Math.max(0, (rowData[col.field] ?? 0) - 1);
                                        onCellValueChange(rowData, col.field, rowData[col.field])
                                    "
                                    variant="ghost"
                                    size="sm"
                                    icon="subtract"></ds-button>
                                <input
                                    type="number"
                                    [placeholder]="0"
                                    [value]="rowData[col.field] | number : '1.0-2'"
                                    (blur)="onCellValueChange(rowData, col.field, $any($event.target).value)" />
                                <ds-button
                                    onkeyup="rowData[col.field] = (rowData[col.field] ?? 0) + 1; onCellValueChange(rowData, col.field, rowData[col.field])"
                                    (click)="rowData[col.field] = (rowData[col.field] ?? 0) + 1; onCellValueChange(rowData, col.field, rowData[col.field])"
                                    variant="ghost"
                                    size="sm"
                                    icon="add"></ds-button>
                            </div>
                            <div *ngSwitchCase="'trafficLight'">
                                <sera-ri-value
                                    [size]="col.customParams?.size ?? 'small'"
                                    [decimals]="col.customParams?.decimals ?? 1"
                                    [value]="rowData[col.field]"
                                    [color]="rowData[col.field + 'Color']"
                                    [withLabel]="false" />
                            </div>
                            <div *ngSwitchCase="'enum'">
                                <span
                                    [title]="(col.customParams?.capitalize ? ((col.enum?.[rowData[col.field]] | translate) | titlecase) : (col.enum?.[rowData[col.field]] | translate)) ?? '-'">
                                    {{
                                    (
                                        col.customParams?.capitalize
                                            ? ((col.enum?.[rowData[col.field]] | translate) | titlecase)
                                            : (col.enum?.[rowData[col.field]] | translate)
                                    ) ?? '-'
                                    }}
                                </span>
                            </div>
                            <div *ngSwitchCase="'buttons'">
                                <div [ngClass]="{ 'button-col': true, 'button-col-gap': col.gap }">
                                    <ng-container *ngFor="let button of col.seraButtons | filterButtonBasedOnDisplayMode : isEditMode : rowData">
                                        <ds-button
                                            *ngIf="(button.showButton ? button.showButton(rowData) : true) && button.type === 'iconButton'"
                                            (click)="button.action({ rowData: rowData, rowIndex: rowIndex })"
                                            (keydown)="button.action({ rowData: rowData, rowIndex: rowIndex })"
                                            [icon]="button.defaultIconClass!"
                                            [pTooltip]="button.label! | translate"
                                            tooltipPosition="top"
                                            [variant]="button.variant ?? 'ghost'"
                                            size="sm">
                                        </ds-button>
                                    </ng-container>
                                </div>
                            </div>
                            <div *ngSwitchCase="'numberToRound'">
                                <span [title]="rowData[col.field] ?? '-'">{{ (rowData[col.field] | number : '1.0-2') ?? '-' }}</span>
                            </div>
                            <div *ngSwitchCase="'date'">
                                <span [title]="rowData[col.field] ? (rowData[col.field] | date : 'd/M/yyyy') : '-'">{{
                                    rowData[col.field] ? (rowData[col.field] | date : 'd/M/yyyy') : '-'
                                }}</span>
                            </div>
                            <div *ngSwitchDefault>
                                <span [title]="rowData[col.field] ?? '-'">{{ rowData[col.field] ?? '-' }}</span>
                            </div>
                        </ng-container>
                    </div>
                </td>
            </ng-container>
        </tr>
    </ng-template>
    <ng-template
        #emptymessage
        let-columns>
        <tr class="sera-table-empty__state__container">
            <td [attr.colspan]="columns.length + 2">
                <div class="sera-table-empty__state__container__content">
                    <sera-image
                        [imageItem]="emptyStateImage"
                        [noStyle]="true"
                        class="sera-table-empty__state__container__content__image">
                    </sera-image>
                    <p class="sera-table-empty__state__container__content__title_bold-text">{{ emptyStateMessage | translate }}</p>
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>
